<template>
  <div class="country-selector">
    <h3
      v-if="!hideMode"
      class="h3"
    >
      Countries access policy
    </h3>

    <md-progress-bar
      v-if="loading"
      md-mode="indeterminate"
    />
    <div
      v-else
      class="node-form__tags tags"
    >
      <div v-if="!hideMode">
        <md-radio
          v-model="mode"
          value="common"
          class="md-primary"
          :disabled="lockedOption && lockedOption !== 'common'"
          @change="modeChanged(mode)"
        >
          Common
        </md-radio>
        <md-radio
          v-model="mode"
          value="blacklist"
          class="md-accent"
          :disabled="lockedOption && lockedOption !== 'blacklist'"
          @change="modeChanged(mode)"
        >
          Blacklist
        </md-radio>
        <md-radio
          v-model="mode"
          value="whitelist"
          class="md-primary"
          :disabled="lockedOption && lockedOption !== 'whitelist'"
          @change="modeChanged(mode)"
        >
          Whitelist
        </md-radio>
      </div>

      <div class="country-picker-wrapper">
        <md-autocomplete
          v-if="mode!=='common'"
          ref="countryAutocomplete"
          v-model="selectedCountry"
          class="tags__input"
          :md-options="countriesOptions"
          :md-fuzzy-search="false"
          @md-selected="addCountry"
        >
          <label>choose country</label>

          <template
            slot="md-autocomplete-item"
            slot-scope="{ item, term }"
          >
            <md-highlight-text :md-term="term">
              {{ item }}
            </md-highlight-text>
          </template>
        </md-autocomplete>
      </div>

      <p v-if="mode==='blacklist' && !hideMode">
        Enable shortcuts for all countries except:
      </p>
      <p v-if="mode==='whitelist' && !hideMode">
        Disable shortcuts for all countries except:
      </p>

      <div>
        <md-chip
          v-for="cname in selectedCountryNames"
          :key="cname"
          class="md-primary"
          md-deletable
          @click="deleteChip(cname)"
        >
          {{ cname }}
        </md-chip>
      </div>
    </div>
  </div>
</template>

<script>
    import {countryOptions, countryNameToCode} from "../../assets/countries_iso/all-iso-codes";

    export default {
        name: "CountrySelector",
        components: {},
        props: {
            shortcutID: { type: String, default: "" },
            "initial-mode": { type: String, default: "" },
            "initial-iso-codes": { type: Array, default() { return []; } },
            loading: Boolean,
            hideMode: Boolean,
            lockedOption: { type: String, default: "" }
        },
        data() {
            return {
                mode: "common",
                countriesOptions: countryOptions,
                selectedCountry: "",
                selectedCountryNames: [],
                selectedISOCodes: []
            };
        },
        watch: {
            "initialMode": "updateModeFromProps",
            "initialIsoCodes": "updateCountriesFromProps",
        },
        mounted() {
            this.shortcutID !== "" && this.shortcutID !== undefined ? this.getShortcutById(this.shortcutID) : true;

            // if props are passed, use them as the initial state
            if (this.$props.initialMode || this.$props.initialIsoCodes) {
                this.updateModeFromProps();
                this.updateCountriesFromProps();
            }

            if (this.$props.hideMode) {
                // setting mode to 'blacklist' so the country field is shown
                this.mode = "blacklist";
            }

            if (this.$props.lockedOption) {
                this.mode = this.$props.lockedOption;
            }
        },
        methods: {
            modeChanged() {
                this.$emit("modeChanged", this.mode);
            },
            addCountry() {
                this.selectedCountryNames.push(this.selectedCountry);
                this.selectedISOCodes.push(countryNameToCode[this.selectedCountry]);
                // clearing input content
                this.selectedCountry = "";
                this.$refs["countryAutocomplete"].searchTerm = "";

                this.$emit("countryListChanged", this.selectedISOCodes);
            },
            deleteChip(cname) {
                console.log(cname);
                this.selectedCountryNames = this.selectedCountryNames.filter(el => {
                    return el !== cname;
                });
                this.selectedISOCodes = this.selectedISOCodes.filter(el =>
                    el !== countryNameToCode[cname]
                );

                this.$emit("countryListChanged", this.selectedISOCodes);
            },
            getShortcutById(id) {
                this.$http.get("/v1/shortcut/id/" + id).then(
                    res => {
                        this.mode = res.data.shortcut.countries_access_type;
                        res.data.shortcut.countries_iso_codes ? this.selectedCountryNames = res.data.shortcut.countries_iso_codes : this.selectedCountryNames = [];
                    },
                    err => {
                        console.error(err);
                    },
                );
            },
            updateModeFromProps() {
                if (this.$props.initialMode) {
                    this.mode = this.$props.initialMode;
                }
            },
            updateCountriesFromProps() {
                this.selectedISOCodes = this.$props.initialIsoCodes
                    ? this.$props.initialIsoCodes.filter(e => typeof e === "string").map(code => code.toUpperCase()) : [];

                const newSelectedCountryNames = [];

                const countryKeys = Object.entries(countryNameToCode);
                this.selectedISOCodes.forEach(
                    code => {
                        const name = countryKeys.find(([n,c]) => code === c)[0];
                        newSelectedCountryNames.push(name);
                    }
                );

                this.selectedCountryNames = newSelectedCountryNames;
            }
        }
    };
</script>
<style lang="scss">
    .country-picker-wrapper {
        display: flex;
        align-items: center;

        .add-county-button {
            height: 35px !important;
        }
    }
</style>
